import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, Subject, throwError } from 'rxjs';
import { switchMap, take, finalize } from 'rxjs/operators';
import { environment } from '../../../environments/environment';

export interface StockPromptLocation {
  id: number; name: string; stock_class: 'MILK' | 'PRODUCT' | 'BOTH';
  milk_balance: string; is_active: number; capacity_warning: boolean;
}

/** A required field at save time, shared by legacy stock forms and delete actions.
 * The backend rolls back before asking for attribution. Never cache/default a choice.
 */
@Injectable({ providedIn: 'root' })
export class StockLocationPromptService {
  pending = false;
  locations: StockPromptLocation[] = [];
  selectedId = 0;
  private choice?: Subject<number>;
  private choosing = false;

  constructor(private http: HttpClient) {}

  choose(dId: number, stockClass: 'MILK' | 'PRODUCT'): Observable<number> {
    if (this.choosing) return throwError(() => ({ error: { message: 'Complete the current location selection first.' } }));
    this.choosing = true;
    return this.http.post<any>(`${environment.apiUrl}/storage_locations/list_locations.php`, { d_id: dId }).pipe(
      switchMap(res => {
        this.locations = (res.locations || []).filter((l: StockPromptLocation) => !!Number(l.is_active) && (l.stock_class === stockClass || l.stock_class === 'BOTH'));
        if (!this.locations.length) return throwError(() => ({ error: { message: 'No compatible active location is available. Configure Storage Locations first.' } }));
        this.selectedId = 0;
        this.pending = true;
        this.choice = new Subject<number>();
        return this.choice.pipe(take(1));
      }),
      finalize(() => { this.pending = false; this.choosing = false; this.choice = undefined; this.selectedId = 0; })
    );
  }
  confirm(): void {
    if (this.locations.some(l => Number(l.id) === Number(this.selectedId))) this.choice?.next(Number(this.selectedId));
  }
  cancel(): void {
    this.choice?.error({ error: { message: 'Stock change cancelled. No stock was saved.' } });
  }
}
